export const PERMISSIONS = {
  DASHBOARD: {
    ACTIVE_JOBS: {
      JOBS_STAGES: {
        EQUIP_SHIPPED: 'dashboard.activejobs.job_stage.equipment_shipped',
        EQUIP_RETURNED: 'dashboard.activejobs.job_stage.equipment_returned',
        OPERATOR_DISPATCHED:
          'dashboard.activejobs.job_stage.operator_dispatched',
        OPERATOR_RETURNED: 'dashboard.activejobs.job_stage.operator_returned',
        JOB_STAGED: 'dashboard.activejobs.job_stage.job_staged',
        NEW_JOB: 'dashboard.activejobs.job_stage.new_job',
        CLOSED: 'dashboard.activejobs.job_stage.closed',
        CANCELLED: 'dashboard.activejobs.job_stage.cancelled'
      },
      UPDATE_JOB_STAGE: 'dashboard.changejobstage.update',
      MARK_JOB_CLOSED: 'dashboard.markasclosed.update',
      EDIT_JOB: 'dashboard.editjob.update',
      ADD_NEW_PROJECT: 'dashboard.newproject.create',
      ADD_COMMENTS_FIELD: 'dashboard.comments_field.create',
      ADD_SHOP_COMMENTS_FIELD: 'dashboard.comments_shop.create'
    },
    ARCHIVE_JOBS: {
      MOVE_TO_ACTIVE_JOB: 'dashboard.archive_jobs.move_to_active.update',
      UPDATE_ARCHIVE_JOB: 'dashboard.archive_jobs.update_archive_job.update'
    }
  },
  CUSTOMER: {
    COMPANY: {
      READ: 'company.read',
      CREATE: 'company.create',
      UPDATE: 'company.update',
      DELETE: 'company.delete'
    },
    REPRESENTATIVE: {
      READ: 'representative.read',
      CREATE: 'representative.create',
      UPDATE: 'representative.update',
      DELETE: 'representative.delete'
    }
  },
  JOB_CONFIGURATION: {
    JOB_STAGE: {
      READ: 'jobconfiguration.jobstage.read',
      CREATE: 'jobconfiguration.jobstage.create',
      UPDATE: 'jobconfiguration.jobstage.update',
      DELETE: 'jobconfiguration.jobstage.delete'
    },
    JOB_TYPE: {
      READ: 'jobconfiguration.jobtypes.read',
      CREATE: 'jobconfiguration.jobtypes.create',
      UPDATE: 'jobconfiguration.jobtypes.update',
      DELETE: 'jobconfiguration.jobtypes.delete'
    },
    JOB_RIGS: {
      READ: 'jobconfiguration.rigs.read',
      CREATE: 'jobconfiguration.rigs.create',
      UPDATE: 'jobconfiguration.rigs.update',
      DELETE: 'jobconfiguration.rigs.delete'
    },
    JOB_LOCATION: {
      READ: 'jobconfiguration.joblocation.read',
      CREATE: 'jobconfiguration.joblocation.create',
      UPDATE: 'jobconfiguration.joblocation.update',
      DELETE: 'jobconfiguration.joblocation.delete'
    }
  },
  EMPLOYEE: {
    READ: 'employee.read',
    CREATE: 'employee.create',
    UPDATE: 'employee.update',
    DELETE: 'employee.delete'
  },
  CALL_OUT_CALENDAR: {
    READ: 'resources.callout_calendar.read',
    CREATE: 'resources.callout_calendar.create',
    UPDATE: 'resources.callout_calendar.update',
    DELETE: 'resources.callout_calendar.delete'
  },
  ROLES: {
    READ: 'roles.read',
    CREATE: 'roles.create',
    UPDATE: 'roles.update',
    DELETE: 'roles.delete'
  },
  RESOURCES: {
    READ: 'hooptimizationcalculator.read'
  },
  INSPECTION_FORMS: {
    OVERHEAD_CRANE: { READ: 'resources.inspection_forms.overhead_crane.read' },
    OBSERVATION_CARD: {
      READ: 'resources.inspection_forms.observation_card.read'
    },
    WASTE_WATER: { READ: 'resources.inspection_forms.waste_water.read' },
    FORKLIFT: { READ: 'resources.inspection_forms.forklift.read' }
  }
};

export type PermissionKey = keyof typeof PERMISSIONS;
